// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['dashboard_cliente']

const DEFAULT_URL = '/dashboard-cliente';

const dashboardClienteBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Dashboard por Cliente',
    to: 'dashboardCliente'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'dashboardCliente',
    component: () => import('@/views/Clientes/Dashboard/DashboardCliente.vue'),
    meta: {
      roles: ROLES,
      title: 'Dashboard por Cliente',
      breadcrumb: dashboardClienteBreadCrumb
    }
  }
];
